export default "__VITE_ASSET__Ba$z9h0H__"